<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- ComboBox Section  -->
    <v-card class="card_superior_container">
      <div class="card_dropdown_container">
        <v-combobox v-model="anoLectivoSelecionado" :items="anoLectivosLista" label="Ano Lectivo" outlined dense v-on:change="pesquisar()"></v-combobox>
        <v-combobox v-model="mesSelecionado" :items="mesesLista" label="Mês" outlined dense v-on:change="pesquisar()"></v-combobox>
        <v-combobox v-model="anoacademicoSelecionado" :items="anosAcademicosLista" label="Ano acadêmico" outlined dense v-on:change="pesquisar()"></v-combobox>
      </div>
      <div class="print_data_container" v-if="ficheiroTxt">
        <v-btn small fab color="primary" v-on:click="gerarHTML()"><v-icon>print</v-icon></v-btn>
      </div>
    </v-card>
    <!-- Nota(OBS) Section -->
    <v-card v-if="!anoLectivoSelecionado || !mesSelecionado || !anoacademicoSelecionado" class="info_dados_container">
      <p><span>Nota: </span>Seleciona o ano lectivo, mês e o ano acadêmico para visualizar os dados</p>
    </v-card>
    <!-- HTML from TXT Section -->
    <v-card>
      <div v-html="ficheiroTxt"></div>
    </v-card>
  </div>
</template>
<script>
import axios from '../../plugins/axios';
import utilitarios from '../../plugins/utilitarios';
import impressaoService from '../../services/impressaoService';
import impressaoUtilitario from '../../utilitarios/impressao.utilitario';
const ls = require('local-storage');
export default {
  data: () => ({
    overlay: false,
    valorDaRequisicao: '',
    ficheiroTxt: '',
    anoLectivoSistema: parseInt(ls.get('anolectivo')),
    anoLectivoSelecionado: '',
    mesSelecionado: '',
    anoacademicoSelecionado: '',
    anoLectivosLista: [],
    mesesLista: [],
    anosAcademicosLista: [],
    util: utilitarios,
    config: null,
    baseUrl: ''
  }),

  created() {
    this.inicializacao();
    this.config = impressaoUtilitario.getConfig();
    this.getUrlImpressao();
  },

  methods: {
    async inicializacao() {
      this.overlay = true;
      try {
        await axios.get('/listarAnosLectivosParaFiltro').then((res) => this.listandoAnosAcademicos(res.data));
        await axios.get('/listarMesesParaFiltro').then((res) => this.listandoOsMeses(res.data));
        await axios.get('/listarAnosAcademicosParaFiltro').then((res) => this.listandoOsAnosAcademicos(res.data));
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os seus dados.');
      } finally {
        this.overlay = false;
      }
    },

    async getUrlImpressao() {
      try {
        this.overlay = true;
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url);
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante o carregamento do endereço do servidor de impressão!');
      } finally {
        this.overlay = false;
      }
    }, 

    // Método responsavél por gerar a lista de anos academicos disponiveis
    listandoAnosAcademicos(objecto) {
      for (let i = 0; i < objecto.length; i++) {
        if (!this.anoLectivosLista.includes(objecto[i].anoLectivo)) {
          this.anoLectivosLista.push(objecto[i].anoLectivo)
        }
      }
    },

    // Método responsavél por gerar a lista de meses disponiveis
    listandoOsMeses(objecto) {
      for (let i = 0; i < objecto.length; i++) {
        let mes = this.descricaoDoMes(objecto[i].mes);
        if (!this.mesesLista.includes(mes)) {
          this.mesesLista.push(mes);
        }
      }
    },

    // Método responsavél por gerar a descrição de cada mês
    descricaoDoMes(pkmes) {
      switch (pkmes) {
        case 1:
          return 'Janeiro'
        case 2:
          return 'Fevereiro'
        case 3:
          return 'Março'
        case 4:
          return 'Abril'
        case 5:
          return 'Maio'
        case 6:
          return 'Junho'
        case 7:
          return 'Julho'
        case 8:
          return 'Agosto'
        case 9:
          return 'Setembro'
        case 10:
          return 'Outubro'
        case 11:
          return 'Novembro'
        case 12:
          return 'Dezembro'
      }
    },

    // Método responsavél por gerar a lista de anos academicos disponiveis
    listandoOsAnosAcademicos(objecto) {
      for (let i = 0; i < objecto.length; i++) {
        if (!this.anosAcademicosLista.includes(objecto[i].anoacademico)) {
          this.anosAcademicosLista.push(objecto[i].anoacademico)
        }
      }
    },

    async pesquisar() {
      let params = {
        anoSelecionado: this.anoLectivoSelecionado,
        anoSistema: this.anoLectivoSistema
      }

      try {
        this.overlay = true;
        if (this.anoLectivoSelecionado && this.mesSelecionado && this.anoacademicoSelecionado) {
          this.valorDaRequisicao = await axios.post('/estatisticaEstudantesFinanceiroTxt', params).then((res) => res.data);
          this.alterarDisplayDaString(this.valorDaRequisicao);
        }
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os seus dados selecionado!');
      } finally {
        this.overlay = false;
      }
    },

    async alterarDisplayDaString(stringText) {
      this.overlay = true;
      try {
        let valorAntigo = `${this.anoLectivoSelecionado}-${this.mesSelecionado}-${this.anoacademicoSelecionado} style="display:none"`;
        let valorSemDados = `semDados style="display: none"`
        let expressaoRegular = new RegExp(valorAntigo, 'g');
        let valorDaRegex = stringText.includes(valorAntigo);
        if (valorDaRegex) {
          this.ficheiroTxt = stringText.replace(expressaoRegular, '');
        } else {
          this.ficheiroTxt = stringText.replace(valorSemDados, '');
        }
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante a exibição dados.');
      } finally {
        this.overlay = false;
      }
    },

    // Método responsavel por criar um HTML com os dados da coleção this.dados[]
    async gerarHTML() {
      this.overlay = true;
      try {
        let periodo = ` 
          <table class="table2">
            <tr>
              <td>
                <div class="logo">
                  <span><img class="logo_img" src="${this.baseUrl}/readfile/${this.config.logo}" alt="Logótipo da Universidade"/></span>
                  <br><span>${this.config.descricao}</span>
                  <br><span>Departamento de Gestão Financeira</span>
                </div>
              </td>
            </tr>
          </table>
          <div class="dados_academicos">
            <span class="tipo_de_doc">Relatório das mensalidades dos estudantes</span><br>
            <span>Ano Lectivo: ${this.anoLectivoSelecionado}</span><br>
            <span>Mês: ${this.mesSelecionado}</span><br>
            <span>Ano acadêmico: ${this.anoacademicoSelecionado}</span>
            <br><span>PDF Gerado em: ${this.data_hora()}</span> 
          </div>
        `
        this.html = `
          <html>
            <head>
              <style>
                * {
                  font-family: "Times New Roman", sans-serif;
                }
                .table2 {
                  border: 0px solid black;
                  margin-left: 0px;
                  margin-right: auto;
                  width: 100%
                }
                .logo {
                  width: 100%;
                  text-align: center;
                  margin-bottom: 10px;
                }
                .logo_img {
                  width:90%;
                  max-width:50px;
                }
                .dados_academicos {
                  border-radius: 15px;
                  border: 1px solid #000000;
                  padding: 15px; 
                  font-size:10px
                }
                table, th, td {
                  border: 0px solid black;
                  border-collapse: collapse;
                  font-size: 8px;
                }
                .th_da_tabela {
                  font-size: 8px !important;
                }
                .container_da_tabela {
                  margin-top: 10px !important;
                }
                .tipo_de_doc {
                  font-weight: bold;
                  font-size: 10px;
                }
              </style>
            </head>
            <body>
              ${periodo}
              ${this.ficheiroTxt}
            </body>
          </html>
        `
        let options = {
          'format': 'A4',
          'border': {
            'right': '9mm',
            'left': '9mm'
          },
          'header': {
            'height': '10mm'
          },
          'footer': {
            'height': '1mm'
          }
        }

        impressaoService.htmlToPdf(this.html, options);
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante a impressão do documento.');
      } finally {
        this.overlay = false;
      }
    },

    // Método responsavél por guardar a data atual
    data_hora() {
      let data = new Date()
      return data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear()) + ' ' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
    },

    // Os dados vêm originalmento no formato "2022-11-21T10:25:40.000Z"
    // Método responsavél por converter no formato "2022-11-21"
    formatarData(data) {
      let newData = data.split('T');
      return newData[0];
    }
  }
}
</script>
<style scoped>
.card_superior_container {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin: 10px auto 10px;
}
.card_dropdown_container {
  display: flex;
}
.print_data_container {
  display: flex;
}
.print_data_container p span {
  font-weight: bold;
}
.print_data_container p {
  margin-right: 10px;
}
.info_dados_container {
  text-align: center;
  width: 98%;
  margin: auto;
  padding: 20px;
}
.info_dados_container span {
  font-weight: bold;
}
.load_container {
  text-align: center;
}
</style>